var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box flex-space-around--center",class:{ selected: _vm.isSelected }},[_c('span',{staticClass:"first-letter-uppercase"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }